import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getProductEnquiries = async () => {
  const response = await axios.get(`${base_url}product-enquiry/all`, getAuthHeaders());
  return response.data;
};

const deleteProductEnquiry = async (id) => {
  const response = await axios.delete(`${base_url}product-enquiry/${id}`, getAuthHeaders());
  return response.data;
};

const getProductEnquiry = async (id) => {
  const response = await axios.get(`${base_url}product-enquiry/get/${id}`, getAuthHeaders());
  return response.data;
};

const updateProductEnquiry = async (enquiry) => {
  const response = await axios.put(
    `${base_url}product-enquiry/edit/${enquiry.id}`,
    { status: enquiry.enquiryData },
    getAuthHeaders()
  );
  return response.data;
};

const productEnquiryService = {
  getProductEnquiries,
  deleteProductEnquiry,
  getProductEnquiry,
  updateProductEnquiry,
};

export default productEnquiryService;
